<template>
  <div>

    <div class="header-seach-box">
      <el-button type="success" class="toTransLfet" @click="addSelectionBtn()">添加精选</el-button>
    </div>  
    <el-card>
      <el-table :data="selectionList">
        <el-table-column label="精选名字" prop="name"></el-table-column>
        <el-table-column label="跳转链接" prop="link"></el-table-column>
        <el-table-column label="优先级" prop="sort"></el-table-column>
        <el-table-column label="简介(收益名称)" prop="intro" ></el-table-column>
        <el-table-column label="产品数据(收益率)" prop="productData"></el-table-column>
        <el-table-column label="特点" prop="specialty"></el-table-column>
        <el-table-column label="推广语" prop="spread"></el-table-column>
        <el-table-column label="显示/隐藏">
            <template slot-scope="scope">
                <el-switch
                    active-color="#13ce66"
                    @change="handleSelectionShowedStatus(scope.row.id, $event)"
                    :value="scope.row.showed"
                ></el-switch>
            </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button type="primary" @click="handleEdit(scope.row.id)">修改</el-button>
                <el-button type="danger" icon="el-icon-delete" circle size="small" @click="handleRemoveSelection(scope.row.id)"/>
            </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="selectionTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>

    <el-dialog title="添加精选类型" class="bk-ui5-dialog" :visible.sync="editDialog">
      <el-form ref="form" label-width="150px">
        <el-form-item label-width="180px" label="精选中文名称">
            <el-input v-model="addSelection.zhName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="精选英文名称">
            <el-input v-model="addSelection.enName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="精选韩文名称">
            <el-input v-model="addSelection.koName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="精选越南文名称">
            <el-input v-model="addSelection.viName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="优先级">
            <el-input v-model="addSelection.sort" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="跳转链接">
            <el-input v-model="addSelection.link" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="简介中文(收益名称)">
            <el-input v-model="addSelection.zhIntro" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="简介英文">
            <el-input v-model="addSelection.enIntro" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="简介韩文">
            <el-input v-model="addSelection.koIntro" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="简介越南语">
            <el-input v-model="addSelection.viIntro" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="产品数据(收益率之类)">
            <el-input v-model="addSelection.productData" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="特点标签中文">
            <el-input v-model="addSelection.zhSpecialty" ></el-input>
        </el-form-item>       
        <el-form-item label-width="180px" label="特点标签英文">
            <el-input v-model="addSelection.enSpecialty" ></el-input>
        </el-form-item> 
        <el-form-item label-width="180px" label="特点标签韩文">
            <el-input v-model="addSelection.koSpecialty" ></el-input>
        </el-form-item> 
        <el-form-item label-width="180px" label="特点标签越南文">
            <el-input v-model="addSelection.viSpecialty" ></el-input>
        </el-form-item>  
        <el-form-item label-width="180px" label="推广语中文">
            <el-input v-model="addSelection.zhSpread" ></el-input>
        </el-form-item> 
        <el-form-item label-width="180px" label="推广语英文">
            <el-input v-model="addSelection.enSpread" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="推广语韩文">
            <el-input v-model="addSelection.koSpread" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="推广语越南文">
            <el-input v-model="addSelection.viSpread" ></el-input>
        </el-form-item>
        <el-form-item label="显示/隐藏">
            <el-switch v-model="addSelection.showed" active-color="#13ce66"/>
        </el-form-item>
      </el-form>  
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editCommitBtn()">提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import api from '../api';
    import "../store";
    import Pagination from "components/pagination";
    import { mapActions, mapGetters, mapState } from "vuex";
    import { formatTable } from "../../../common/tools.js";

    export default {
        name: "selection",
        data() {
            return {
                pager: {
                    page: 1,
                    size: 10,
                },
                editDialog: false,
                addSelection: {},
                
            };
        },    
        computed: {
            ...mapState("ProductManage", [
                "selectionList",
                "selectionTotal",
            ]),
        },
        methods:{
            ...mapActions("ProductManage", [
                "getSelectionList",
                "updateSelectionShowedStatus",
                "createOrUpdateProductSelection",
                "deleteSelection",
                ]),
            querySelectionData(clr) {
                if (clr) this.pager.page = 1;
                let q = {
                page: this.pager.page,
                size: this.pager.size,
                };
                this.getSelectionList(q);
            },

            handlPageChanged(pagination) {
                this.pager.page = pagination.page;
                this.pager.size = pagination.size;
                this.querySelectionData();
            },

            handleSelectionShowedStatus(selectionId, showed) {
                this.$confirm("确认要进行此操作吗？", "提示", { type: "warning" })
                .then(() => {
                        this.updateSelectionShowedStatus({selectionId, showed }).then(() => {
                        this.$message.success("操作成功！");
                        this.querySelectionData();
                    });
                });
            },

            addSelectionBtn(){
                this.addSelection = {};
                this.editDialog = true;
            },

            handleEdit(id) {
                api.getSelectionOne({selectionId:id}).then(({data}) =>{
                    this.addSelection = data;
                    this.editDialog = true;
                });
            },

            editCommitBtn() {
                this.createOrUpdateProductSelection(this.addSelection).then(() =>{
                    this.$message.success("操作成功！");
                    this.addSelection = {};
                    this.editDialog = false;
                    this.querySelectionData();
                })
            },

            handleRemoveSelection(selectionId) {
                this.$confirm("确认要删除吗？", "提示", { type: "warning" })
                .then(() => {
                        this.deleteSelection({selectionId}).then(() => {
                        this.$message.success("操作成功！");
                        this.querySelectionData();
                    });
                });
            }

        },

        mounted() {
            this.querySelectionData();
        },
        
        components: {
            Pagination,
        },
    }
</script>

<style scoped>

</style>
